import "./edit-travel-voucher.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet } from "react-router-dom";

import TravelVoucherFile from "../../preview-file/travel-voucher-file";
import { useEditTravelVoucher } from "./edit-travel-voucher.hook";

export function EditTravelVoucher() {
  const {
    isLoading,
    travelVoucherError,
    formMethod,
    actions,
    fileRef,
    handleBack,
    handleAction,
  } = useEditTravelVoucher();
  const { getValues } = formMethod;
  const invoiceId = getValues("baseInvoice") || "";

  const title = <h1>Edit Travel Voucher</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        {/* <FormTravelVoucher /> */}
        <TravelVoucherFile invoiceId={invoiceId} fileRef={fileRef} />
        {/* <Outlet /> */}
      </section>
    </div>
  );

  return (
    <div id="EditTravelVoucher" className="travel-voucher">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {travelVoucherError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditTravelVoucher;
